import React from "react";

const TrustBar = () => {


    return (
        <div className="trust-bar">
            <div className="trust-bar-inner">
                {[["📋", "בדיקת רקע מלאה"], ["💳", "עסקה מאובטחת"], ["🔧", "בדיקה טכנית"], ["📞", "תמיכה אישית"]].map(([icon, text], i) => (
                    <>
                        <div className="trust-item" key={text}><span className="trust-icon" key={"k-" + i}>{icon}</span>{text}</div>
                        {i < 4 && <div className="trust-sep" key={`s${i}`} />}
                    </>
                ))}
            </div>
        </div>
    );
};

export default TrustBar;